<template>
  <!--copied from MyTable.vue-->
  <div class="container">
    <table class="myTable">
      <col v-for="(val, key) in columnWidths" :style="`width:${val}%;`" :key="key" />
      <thead>
        <tr>
          <th v-for="field in header" v-bind:key="field.name" :class="field.class">
            {{ field.name }}
          </th>
        </tr>
      </thead>
      <tbody>
        <LineItemRow
          v-for="(item, index) in lineItems"
          v-model="lineItems[index]"
          :key="index"
          :descOptions="descOptions"
          @delete="deleteRow(index)"
        ></LineItemRow>
      </tbody>
      <tfoot>
        <tr>
          <td>
            <p class="flex flex-row-reverse">Tax:</p>
          </td>
          <td class="w-full px-3 py-1 text-sm shadow-sm bg-slate-100 text-slate-700">
            {{ formatDollars(netTax) }}
          </td>
        </tr>
        <tr>
          <!--<td></td>-->
          <td class="w-full px-3 py-1 text-sm shadow-sm bg-slate-100 text-slate-700">
            <p class="flex flex-row-reverse">Total:</p>

            <!--TableInput v-model="'Total:'"></TableInput> 
                        <input class="form-control" readonly disabled value="Total:">-->
            <!--input type="text" value="Total:" class="block w-full px-3 py-1 bg-white border border-slate-300 rounded-md text-sm shadow-sm placeholder-slate-400 disabled:bg-slate-100 disabled:text-slate-700">
                    -->
          </td>
          <td class="w-full px-3 py-1 text-sm shadow-sm bg-slate-100 text-slate-700">
            {{ netValue + netTax }}
            <!--input v-model="netValue" class="form-control" name="valueTotal" readonly disabled>-->
          </td>
        </tr>
      </tfoot>
    </table>
  </div>

  <div class="container mb-3">
    <div class="form-btns">
      <!--FormButtons :model="lineItems" :initial="props.lineItems" @revertComponent="revertTable"></FormButtons-->

      <FormBtn @clicked="addRow" :name="'Add Row'"></FormBtn>
      <!--<button type="button" class="btn btn-warning" @click="revertTable" disabled>Revert Table</button>-->
    </div>
  </div>

  <!--div class="debug">
        <p>Invoice-table:</p>
        <p>props.lineItems = {{ props.lineItems }}</p>

        <p>lineItems (ref) = {{ lineItems }}</p>
        <p>addBtnDisabled = {{ addBtnDisabled }}</p>
        <p>descCol = {{ descCol }}</p>
        <p>valCol = {{ valCol }}</p>
        <p>rowCount = {{ rowCount }}</p>
        <p>netValue = {{ netValue }}</p>
        <p>netTax = {{ netTax }}</p>
        <p>taxRate = {{ props.taxRate }}</p>
    </div>-->
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch, toValue } from 'vue'
import { loadingStart, loadingEnd } from '@/js/common.js'
//import RatesController from '../js/idb/RatesController';
import { useInvoiceStore, useRatesStore } from '@/stores'
import { storeToRefs } from 'pinia'
//import TableInput from './Table-input.vue';
//import TableListbox from './Table-listbox.vue';
import { FormBtn } from '@/components/form'
import LineItemRow from './Lineitem-row.vue'
const invoiceStore = useInvoiceStore()
const ratesStore = useRatesStore();

//const hideTaxCol = true;
const columnWidths = [80, 10]


const { allRates } = storeToRefs(ratesStore);
const rates = ref([])
/*const rates = computed(() =>{
  return allRates.value;
})*/

//import FormButtons from './FormButtons.vue';
import type { LineItem } from '@/types/types'

const header = [
  //{ 'name': 'itemNo', 'class': 'col-md-1' },
  { name: 'description', class: 'col-span-3' },
  { name: 'value', class: 'col-span-1' },
  //{ 'name': 'tax', 'class': 'col-md-2' },
  { name: 'delete', class: 'col-md-2' }
]

const props = defineProps({
  taxRate: { type: Number, required: true }
  // lineItems: { type: Array, required: true },
  // netValue: { type: Number, required:true},   //TODO remove?
  // netTax: { type:Number, required:true}   //TODO remove?
})

const lineItems = defineModel<Array<LineItem>>('lineItems', { required: true })
const netValue = defineModel<number>('netValue')
const netTax = defineModel<number>('netTax')
const jobRate = defineModel<string>('jobRate', { default: 'rate1' })

const addBtnDisabled = ref<boolean>(false)

async function initRates(){
  rates.value = [];
  try{
    rates.value = await allRates.value;
  }catch(error){
    console.error('..trapped error on initRates...:' + error.toString());
  }
}

onMounted(async() => {
  console.log('Invoice-table mounted..')
  await initRates()
  //reactive copy doesnt really work for updating, try using ref
  //lineItems.value = JSON.parse(JSON.stringify(props.lineItems));
})


/**
 * Adjust the index nos
 * @param {Number} index
 */
function deleteRow(index: number) {
  console.log('deleteRow for index : ' + index)
  lineItems.value.splice(index, 1)
  let i = 1
  lineItems.value.forEach((entry) => {
    entry['itemNo'] = i
    i++
  })
}

/**
 * format the number into 2 decimal places max
 * @param {Number} num
 */
function formatDollars(num: number) {
  return Math.round(num * 100) / 100
}
/** TODO this shouldn't be reactive
 * watch change in table values to update parent component
 *
 watch(() => invEntries.value, (newVal, oldVal) => {
    console.log("invEntries changes, updating with parent...");
    emits('invEntriesUpdated',netValue,netTax);
 }, {deep:true});
*/

/**
 * conputed description column for watching
 */
const descCol = computed(() => {
  let temp
  try {
    temp = lineItems.value.map((entry) => {
      return entry['description']
    })
  } catch (err) {
    console.log("descCol can't be computed...")
  }
  return temp
})

/**
 * conputed value column for watching
 */
const valCol = computed(() => {
  let temp
  try {
    temp = lineItems.value.map((entry) => {
      return entry['value']
    })
  } catch (err) {
    console.log("valCol can't be computed...")
  }
  return temp
})

/**
 * Watch for changes on description fields
 * update value if description matches an entry in the rates array
 */
watch(
  () => descCol.value,
  (newVal, oldVal) => {
    //console.log('Invoice-table watching invEntries.description fired...')
    //console.log('...newVal=' + JSON.stringify(newVal));
    //console.log('...oldVal=' + JSON.stringify(oldVal));

    //find the index (Row number) by comparing new and old
    let rowNo = -1
    //console.log("...newVal.length = " + newVal.length);
    try {
      for (let i = 0; i < newVal.length; i++) {
        if (newVal[i] != oldVal[i]) {
          rowNo = i
          break
        }
      }
    } catch (err) {
      console.log('... no oldVal yet..')
    }
    //console.log("...rowNow changed = " + rowNo);
    if (rowNo >= 0) {
      let newRate = null
     //console.log('...newVal[rowNo] = ' + newVal[rowNo])
      try {
        newRate = rates.value.find(
          (rate) => rate.description.toString().trim() == newVal[rowNo].toString().trim()
        )
        //console.log("...newRate = " + JSON.stringify(newRate));
      } catch (err) {
        console.log('...error finding matching rate')
      }
      if (newRate) {
        lineItems.value[rowNo]['value'] = parseInt(newRate[jobRate.value])
      }
    }
  },
  { deep: true }
)

/**
 * watch for changes to value column, update tax col to match
 */
watch(
  () => valCol.value,
  (newVal, oldVal) => {
    //console.log('Invoice-table watching invEntries.val fired...')
    // console.log('...newVal=' + JSON.stringify(newVal));
    //console.log('...oldVal=' + JSON.stringify(oldVal));

    //find the index (Row number) by comparing new and old
    let rowNo = -1
    //console.log("...newVal.length = " + newVal.length);
    try {
      for (let i = 0; i < newVal.length; i++) {
        if (newVal[i] != oldVal[i]) {
          rowNo = i
          break
        }
      }
    } catch (err) {
      console.log('... no oldVal yet..')
    }
    if (rowNo >= 0) {
      lineItems.value[rowNo]['tax'] = formatDollars(
        Number(lineItems.value[rowNo]['value'] * props.taxRate)
      )
    }

    //calculated the totals
    let total = 0
    newVal.forEach((val) => {
      total += parseFloat(val)
    })
    netValue.value = formatDollars(Number(total))
    netTax.value = formatDollars(Number(total * props.taxRate))
  },
  { deep: true }
)

/**
 * watch for jobRate changes from parent:
 */
watch(
  () => jobRate.value,
  (newVal, oldVal) => {
    console.log('Invoice-table watching jobRate fired..., newVal = ' + newVal)
    lineItems.value.map((item) => {
      let newRate = rates.value.find(
        (rate) => rate.description.toString().trim() == item.description.toString().trim()
      )
      item.value = newRate[newVal]
      return item
    })
  }
)

/* if (rowNo >= 0) {
        let newRate = null;
        console.log("...newVal[rowNo] = " + newVal[rowNo]);
        try {
            newRate = rates.value.find(rate => rate.description.toString().trim() == newVal[rowNo].toString().trim());
            //console.log("...newRate = " + JSON.stringify(newRate));


        } catch (err) {
            console.log("...error finding matching rate");
        }
        if (newRate) {
            lineItems.value[rowNo]['value'] = parseInt(newRate[jobRate.value]);
        }
    }*./





/*
const emits = defineEmits([ //is this needed?
    'rowAdded'
]);
*/
const maxRows = 6
/**
 * TODO this is returning the length of the lineItems.value as a string....
 */
const rowCount = computed(() => {
  console.log('Invoice-table computing rowCount...')
  const arr = toValue(lineItems.value)
  //return 3;
  let count = 0
  try {
    //console.log("...invEntries array length = " + arr.length);
    count = Math.min(arr.length, maxRows)
  } catch (err) {
    console.log('error computing rowCount, no length yet...')
    count = -1
  }

  if (count >= maxRows) {
    addBtnDisabled.value = true
  } else {
    addBtnDisabled.value = false
  }
  return count
})


/**
 * computed column of description from rates object array
 */
const descOptions = computed(() => {
  console.log('Invoice-table computing descOptions from rates...')
  try {
    return rates.value.map((entry) => {
      return entry['description']
    })
  } catch (error) {
    console.error('Invoice-table.descOptions not ready.. ' + error)
    return [{ description: 'empty' }]
  }
})

/**
 * fetch the array of rate objects from DB
 *
async function fetchRates() {
  console.log('Invoice-table.fetchRates()..')
  loadingStart()
  //const rateOptions = await DbAdapter.getInvoiceRates();
  // const idb = await IDBWrapper.create();
  // const rateOptions = await idb.fetchRates();
  const rateOptions = await invoiceStore.getAllRates()
  // const rateOptions = await RatesController.fetchAll();
  //console.log("...fetch rate options : " + JSON.stringify(rateOptions));
  //reactively update rates:
  rates.value = []
  rateOptions.forEach((rate) => {
    rates.value.push(rate)
  })
  //rates.value = rateOptions.splice();
  //console.log('...returning rates = ' + rates.value)
  loadingEnd()
}*/

/**
 * only add up to 6 total rows
 */
function addRow() {
  console.log('Invoice-table.addRow()..')
  if (rowCount.value < maxRows) {
    lineItems.value.push({ itemNo: rowCount.value + 1, description: '', value: 0, tax: 0 })
  } //else{
  //    addBtnDisabled.value=true;
  //}
}

</script>

<style lang="css" scoped>
.form-btns {
  margin-top: 1rem;
}
/*
table.invoice-table > tbody > tr > td > input,
table.invoice-table > tbody > tr > td > select,
table.invoice-table > tfoot > tr > td > input {
    padding: .5em;
    width:100%;
    border: none;
    outline:none;


}*/
/*
table.invoice-table > tfoot > tr > td > input {
    font-weight: bold;
}*/
</style>
